import Store from 'src/store/index'
import date from 'src/store/modules/date/index'
import wordingModules from 'src/store/modules/wording'
import generalModules from 'src/store/general'
import getEnv from 'src/getEnv'

import {
  commonDate,
  digitGroup
} from 'src/helpers'
const { lang } = generalModules.state()
const wording = wordingModules.state

export const tablePoAllStatus = {
  columns: [
    {
      name: 'po_no',
      field: row => {
        return `
            <a href="/po/detail/${row.id}/${encodeURIComponent(row.po_no)}" class="goto-preview-page">
              <strong class="text-primary text-underline">${row.po_no}</strong>
            </a>
            <div class="text-grey-7">
            ${
              row.supplier_name
              ? row.supplier_name
              : '-'
            }
          </div>
          `
      },
      label: 'No. Purchase Order',
      align: 'left',
      sortable: true
    },
    {
      name: 'so_no',
      field: row => {
        return `
            <a
              href="/so/detail/${row.so_id}/${encodeURIComponent(row.so_no)}"
              class="goto-preview-page"
            >
              <strong class="text-primary text-underline">${row.so_no}</strong>
            </a>
            <div class="text-grey-7">
              ${row.so_no_cust || '-'}
            </div>
          `
      },
      label: 'No. Sales Order',
      align: 'left',
      rowClass: 'td-width-small'
    },
    {
      name: 'customer_name',
      field: row => {
        return `
            <div">
              ${row?.customer_name}
            </div>
            <div class="text-grey-7">
            ${
              {
                PROJECT_OWNER: 'Pemilik Proyek',
                ARCHITECT: 'Arsitek',
                DEVELOPER: 'Developer',
                CONTRACTOR: 'Kontraktor',
                OTHER: 'Lainnya'
              }[row?.customer_type] || '-'
            }
          </div>
          `
      },
      label: 'Customer',
      align: 'left'
    },
    {
      name: 'po_date',
      field: 'po_date',
      label: 'Tgl. Pemesanan',
      sortable: true,
      commonDate: true,
      align: 'left'
    },
    {
      name: 'payment_type',
      field: row => {
        if (!row.payment_type) return '-'

        let terminDay = ''
        if (row.payment_type !== 'CBD') {
          if (row?.termin_day) {
            terminDay = `<div class="small text-grey-6">
              ${row.termin_day + ' Hari'}
            </div>`
          }
        }

        return `
            <div>
              ${
                {
                  CBD: 'CBD',
                  TEMPO: 'Tempo'
                }[row.payment_type] || 'Tempo'
              }
            </div>
            ${terminDay}
          `
      },
      label: 'Jenis Pembayaran',
      sortable: true,
      align: 'left'
    },
    {
      name: 'items',
      field: row => {
        return `<div class="flex column">
            <div>${row?.items[0]?.name}</div>
            <small class="text-grey-7 ${!row?.items || row?.items.length === 1 ? 'hidden' : ''}">
              + ${row?.items.length - 1} Lainnya
            </small>
          </div>`
      },
      label: 'Jumlah Pembelian',
      sortable: true,
      align: 'left'
    },
    {
      name: 'totalPrice',
      field: row => {
        return 'Rp ' + digitGroup(row?.total_price)
      },
      label: 'Nilai PO',
      sortable: true,
      align: 'right',
      rowClass: 'text-no-wrap text-right'
    },
    {
      name: 'confirmAt',
      field: 'confirm_at',
      label: 'Tgl. Dikonfirmasi',
      sortable: true,
      commonDate: true,
      align: 'left'
    },
    {
      name: 'received_by',
      field: row => {
        const web = `
            <div class="custom-badge-green dense">
              <img
                src="${require('src/assets/images/icons/12x12-laptop.svg')}"
                class="color-green"
                alt="icon"
              >
              <span class="q-ml-xs">${row.received_by}</span>
            </div>
            `
        const user = `
            <div class="custom-badge-purple dense">
              <img
                src="${require('src/assets/images/icons/12x12-user-purple.svg')}"
                style="
                alt="icon"
              >
              <span class="q-ml-xs">${row.received_by}</span>
            </div>
            `
        return {
          CMS: user,
          IMS: web
        }[row.received_by]
      },
      label: 'Diterima Oleh',
      sortable: true,
      align: 'left'
    },
    {
      name: 'deliveryAt',
      field: 'delivery_at',
      label: 'Tgl. Selesai Dikirim',
      sortable: true,
      commonDate: true,
      align: 'left'
    },
    {
      name: 'paymentDate',
      field: 'payment_date',
      label: 'Tgl. Pembayaran',
      sortable: true,
      commonDate: true,
      align: 'left'
    },
    {
      name: 'status',
      field: row => {
        return `<div class="custom-badge-${
            {
              CANCELED: 'red',
              REJECTED: 'red'
            }[row.status] || 'green'
          } dense">
            ${wording[lang].poStatus[row.status]}
            </div>`
      },
      label: 'Status',
      sortable: true,
      align: 'left'
    },
    {
      name: 'action',
      label: 'Aksi',
      align: 'center',
      field: row => {
        const nocoData = {
          'Reference No': row.po_no,
          'Vendor Name': row.supplier_name,
          'Customer Name': row.customer_name,
          'PO Amount': row.total_price,
          'PO Payment Terms': row.payment_term_supplier,
          'PO Date': row.po_date,
          'PO Net Terms': row.termin_day
        }

        const queryParams = new URLSearchParams(nocoData).toString()
        const apUrl = `${getEnv('NOCO_FORM_URL')}${getEnv('NOCO_FORM_AP_ID')}?${queryParams}&Type=AP`
        const ongkirUrl = `${getEnv('NOCO_FORM_URL')}${getEnv('NOCO_FORM_ONGKIR_ID')}?${queryParams}&Type=Ongkir`

        return `
          <span
            class="text-primary text-weight-bold q-mt-xs inline-flex items-center gap-2 cursor-pointer open-iframe-drawer"
            data-url="${apUrl}"
            data-title="Ajukan Pembayaran"
          >
            Ajukan Pembayaran
          </span>
          <br/>
          <span
            class="text-primary text-weight-bold q-mt-xs inline-flex items-center gap-2 cursor-pointer open-iframe-drawer"
            data-url="${ongkirUrl}"
            data-title="Lain-lain"
          >
            Lain-lain
          </span>
        `
      }
    }
  ]
}

export const tableDoByPoListTab = {
  columns: [
    {
      name: 'do_no',
      label: 'No. DO',
      align: 'left',
      field: row => {
        return `<strong class="text-primary">${row.do_no}</strong>`
      }
    },
    {
      name: 'created_at',
      field: row => commonDate({
        date: row.created_at,
        useDayName: true
      }),
      label: 'Tanggal DO Dibuat',
      align: 'left',
      rowClass: 'text-no-wrap'
    },
    {
      name: 'delivery_at',
      field: row => row.delivery_at
        ? commonDate({
          date: row.delivery_at,
          useDayName: true
        })
        : '-',
      label: 'Tanggal Diterima',
      align: 'left',
      rowClass: 'text-no-wrap'
    },
    {
      name: 'return_letter_at',
      field: row => row.return_letter_at
        ? commonDate({
          date: row.return_letter_at,
          useDayName: true
        })
        : '-',
      label: 'Tanggal Surat Jalan Balik',
      align: 'left',
      rowClass: 'text-no-wrap'
    },
    {
      name: 'product',
      field: row => {
        const { product } = row
        const hasItem = product.length > 0
        const qty = `${product.length - 1}+ produk lainnya`
        return hasItem
          ? `
            <div class="column text-left">
              <div class="q-mb-xs">
                ${product[0]?.product_name}
              </div>
              <div
                class="no-margin text-weight-bold text-primary ${product.length <= 1 && 'hidden'}"
                style="font-size: 12px"
              >
                ${qty}
              </div>
            </div>
          `
          : '-'
      },
      label: 'Jumlah Barang',
      align: 'left',
      rowClass: 'td-width-medium'
    },
    {
      name: 'status',
      field: 'status',
      label: 'Status Pengiriman',
      align: 'left',
      format: val => {
        const status = wording[lang].doStatus[val]
        if (val && status) {
          const badgeClass = val !== 'CANCELED' ? 'green' : 'red'
          return `
            <div role="alert" class="custom-badge-${badgeClass} dense">
              ${status}
            </div>
          `
        }

        return '-'
      }
    }
  ]
}

export const poFormProductsTable = {
  columns: [
    {
      name: 'product',
      field: row => {
        const fullName = row?.product_data?.product?.full_name || row?.product_data?.product?.name || '-'
        const img = row?.image
          ? row?.image
          : require('assets/images/image-not-found-small.jpg')
        return `
        <div class="flex items-center no-wrap gap-3">
          <img
            src="${img}"
            width="32px"
            height="32px"
            alt="img"
            style="
              border-radius: 5px;
              border: solid 1px #ddd;
              object-fit: cover;
            "
          />
          <div>
            <div class="flex items-center">
              <div class="q-mr-sm">
                  <strong class="ellipsis-3-lines">
                    ${fullName}
                  </strong>
              </div>
              <div>
                  <img
                  src="${require('assets/images/icons/view-notes.svg')}"
                  width="16px"
                  height="16px"
                  class="open-note cursor-pointer flex items-center"
                  data-note="${row?.note}"
                  alt="img"
                  />
                </div>
            </div>
            ${
              row.product_data?.variant &&
              !!row.product_data?.variant.length
                ? `<div class="text-capitalize text-grey-7">
                    <span>
                      ${row.product_data.variant
                        .filter((item) => item.value !== 'default')
                        .map((item) => item.value)}
                    </span>
                  </div>`
                : ''
            }
          </div>
      </div>
        `
      },
      label: 'Nama Produk',
      sortable: false,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'dateSend',
      field: row => {
        return row.shippingAt
          ? `<span class="text-weight-bold">${
            date.actions.COMMON_DATE(Store(), {
              date: new Date(row.shippingAt),
              useSecond: false
            })}</span>`
          : '-'
      },
      label: 'Tanggal Pengiriman',
      sortable: false,
      align: 'left',
      rowClass: 'text-left'
    },
    // {
    //   name: 'estimate',
    //   field: row => {
    //     return row.shippingList
    //       ? row.shippingList.length
    //         ? `<div class="text-primary text-weight-bold">${row.shippingType}</div>
    //             <div class="custom-toggle">
    //               <label>
    //                 <input type="checkbox"/>
    //                 <div class="custom-toggle--text">
    //                   <div class="text-no-wrap">
    //                     ${row.shippingList.length} Jadwal Pengiriman
    //                   </div>
    //                 </div>

    //                 <div class="custom-toggle--content">
    //                   ${
    //                     row.shippingList
    //                       .map(item => `<div class="text-caption text-no-wrap">${commonDate({
    //                         date: item
    //                       })}</div>`)
    //                       .join('')
    //                   }
    //                 </div>
    //               </label>
    //             </div>`
    //         : `<div class="text-primary text-weight-bold">${row.shippingType}</div>`
    //       : `<div class="text-primary text-weight-bold">${row.shippingType}</div>
    //         <div class="text-caption text-no-wrap">${commonDate({ date: row.shippingAt })}</div>`
    //   },
    //   label: 'Estimasi Tiba',
    //   sortable: false,
    //   align: 'left'
    // },
    {
      name: 'quantity',
      field: row => {
        return `
        <div class="text-bold">${digitGroup(row.qty)}/${digitGroup(row.defaultQty)}</div>
        <div class="text-caption text-grey-7">
            ${row.unit}
          </div>
        `
      },
      label: 'Jumlah Pembelian',
      sortable: false,
      align: 'right',
      rowClass: 'text-right'
    }
  ]
}

export const poFormIncomeTable = {
  columns: [
    {
      name: 'name',
      field: 'name',
      label: 'Nama',
      sortable: true,
      align: 'center'
    },
    {
      name: 'date',
      field: 'date',
      label: 'Tanggal',
      sortable: true,
      align: 'center'
    },
    {
      name: 'type',
      field: 'type',
      label: 'Jenis',
      sortable: true,
      align: 'center'
    },
    {
      name: 'value',
      field: 'value',
      label: 'Nilai',
      sortable: true,
      align: 'center'
    },
    {
      name: 'document',
      field: 'document',
      label: 'Dokumen Tambahan',
      sortable: true,
      align: 'center'
    }
  ]
}

export const poFormModalVendor = {
  columns: [
    {
      name: 'name',
      field: 'warehouse',
      label: 'Nama Vendor',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'purchasePrice',
      field: 'purchase_price',
      label: 'Harga Beli',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'address',
      field: 'address',
      label: 'Alamat Gudang',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'vendor',
      label: 'Vendor',
      sortable: false,
      align: 'center',
      rowClass: 'text-center'
    }
  ]
}
